import {tagClarityEvent} from './clarity';

export const clarityEvents = {
  // Learner
  courseViewed: (courseId: string) =>
    tagClarityEvent('course_viewed', {course_id: courseId}),
  courseEnrolled: (courseId: string) =>
    tagClarityEvent('course_enrolled', {course_id: courseId}),
  videoStarted: (videoId: string) =>
    tagClarityEvent('video_started', {video_id: videoId}),
  videoCompleted: (videoId: string) =>
    tagClarityEvent('video_completed', {video_id: videoId}),

  // Instructor
  contentCreationStarted: () => tagClarityEvent('content_creation_started'),
  aiGenerationStarted: () => tagClarityEvent('ai_generation_started'),
  aiGenerationCompleted: (lessonId: string) =>
    tagClarityEvent('ai_generation_completed', {lesson_id: lessonId}),
  microlessonPublished: (lessonId: string) =>
    tagClarityEvent('microlesson_published', {lesson_id: lessonId}),
  courseCreated: (courseId: string) =>
    tagClarityEvent('course_created', {course_id: courseId}),
  courseDeleted: (courseId: string) =>
    tagClarityEvent('course_deleted', {course_id: courseId}),
  videoEditorOpened: (videoId: string) =>
    tagClarityEvent('video_editor_opened', {video_id: videoId}),
  videoSaved: (videoId: string) =>
    tagClarityEvent('video_saved', {video_id: videoId}),

  // Payment
  subscriptionCompleted: (planType: string) =>
    tagClarityEvent('subscription_completed', {plan_type: planType}),

  // Analytics
  analyticsViewed: () => tagClarityEvent('analytics_viewed'),
  courseLearnersAnalyticsViewed: (courseId: string) =>
    tagClarityEvent('course_learners_analytics_viewed', {course_id: courseId}),
  reportGenerated: (reportType: string) =>
    tagClarityEvent('report_generated', {report_type: reportType}),

  // Learners Management
  learnersListViewed: () => tagClarityEvent('learners_list_viewed'),
  learnerInvited: (count: string) =>
    tagClarityEvent('learner_invited', {count}),

  // Search & Navigation
  librarySearchPerformed: (query: string) =>
    tagClarityEvent('library_search_performed', {search_query: query}),
  libraryViewed: () => tagClarityEvent('library_viewed'),

  // Settings
  settingsOpened: () => tagClarityEvent('settings_opened'),
  settingChanged: (settingName: string, value: string) =>
    tagClarityEvent('setting_changed', {setting_name: settingName, value}),

  // AI Assistant
  aiAssistantOpened: () => tagClarityEvent('ai_assistant_opened'),

  // Microlessons
  microlessonsListViewed: () => tagClarityEvent('microlessons_list_viewed'),
  microlessionEditorOpened: (lessonId: string) =>
    tagClarityEvent('microlesson_editor_opened', {lesson_id: lessonId}),

  // Courses
  coursesListViewed: () => tagClarityEvent('courses_list_viewed'),
  courseEditorOpened: (courseId: string) =>
    tagClarityEvent('course_editor_opened', {course_id: courseId}),
};
